import sources from 'helpers/sources';

angular.module('gym.pos').controller('ReconciliationSalesModal', ["$scope", "$rootScope", "$modalInstance", "$http", "day", "sales", "currency", function($scope, $rootScope, $modalInstance, $http, day, sales, currency) {
  $scope.day = day;
  $scope.sales = sales;
  $scope.currency = currency;
  $scope.getTotalPaid = function() {
    return _.reduce(sales, function(memo, sale) {
      return memo + parseFloat(sale.total_amount_payable);
    }, 0);
  };
  $scope.setStatus = function(action) {
    var url;
    $scope.loading = true;
    url = `${sources.reconciliation($rootScope.gym.id, day.id)}/${action}`;
    return $http.put(url).then(function() {
      return $modalInstance.close();
    });
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
